import { addClass, removeClass } from '~/js/utils/class-management';
import useWindowSize from '~/js/hooks/use-window-size';

function createTablePagination(
  rows: HTMLTableRowElement[],
  table: HTMLTableElement,
  itemsPerPage: number
) {
  const paginationCount = Math.ceil(rows.length / itemsPerPage);

  const render = (page = 0) => {
    const { isMobile } = useWindowSize();
    rows.forEach((row) => {
      row.style.display = 'none';
    });

    rows
      .slice(page * itemsPerPage, (page + 1) * itemsPerPage)
      .forEach((row) => {
        row.style.display = isMobile ? 'block' : 'table-row';
      });
  };

  const paginationBlocks = Array(paginationCount)
    .fill(0)
    .map((item, idx) => {
      const page = idx + 1;
      const button = document.createElement('button');
      button.innerText = page.toString();
      button.addEventListener('click', () => {
        removeClass(
          table.parentElement?.querySelector(
            'button.active'
          ) as HTMLButtonElement,
          'active'
        );
        addClass(button, 'active');
        render(idx);
      });
      if (idx === 0) {
        addClass(button, 'active');
      }
      return button;
    });

  const pager = document.createElement('div');
  pager.classList.add('table-pagination');

  paginationBlocks.forEach((button) => {
    pager.insertAdjacentElement('beforeend', button);
  });

  const tableHeadWrap = table.parentElement?.querySelector(
    '.table-head-wrap'
  ) as HTMLDivElement;

  tableHeadWrap.insertAdjacentElement('afterbegin', pager);

  render();
}

export default createTablePagination;
